import React, { useMemo } from 'react'
import { Button, Container, Content, Footer } from './styles'
import { ModalHeader } from '../../ModalComponents/ModalHeader'
import { ReferringPhysicianDetails } from '../../ReferringPhysicianDetails'
import { ModalLongInformations } from '../../ModalComponents/ModalLongInformations'
import { IconComponent } from '~/assets/icons/component'
import { IImagingTest } from '~/interfaces'

interface ImagingTestDetailsContentProps {
  imagingTestDetails: IImagingTest
}

export const ImagingTestDetailsContent = ({ imagingTestDetails }: ImagingTestDetailsContentProps): JSX.Element => {
  const redirectToImagesOfTest = ({ accessionNumber }) =>
    window.open(
      `http://ris.einstein.br/BR_Customizations/ShowPacs/Default.aspx?AccNr=${encodeURIComponent(accessionNumber)}`
    )

  const handleOpenPacs = async () => {
    redirectToImagesOfTest({ accessionNumber: imagingTestDetails?.accessionNumber })
  }

  const isDisabled = useMemo(() => {
    if (!imagingTestDetails?.accessionNumber) {
      return true
    }

    return false
  }, [imagingTestDetails])

  const renderLongInformations = (value: string | string[]) => {
    if (Array.isArray(value)) {
      return value.map((_data, index) => <ModalLongInformations key={index} value={_data} />)
    }
    return <ModalLongInformations key={value} valueHTML={value} />
  }

  return (
    <Container>
      <ModalHeader title={imagingTestDetails.description} datetime={imagingTestDetails.startDate} />
      <ReferringPhysicianDetails physician={imagingTestDetails.referringPhysician} />
      <hr />
      <Content>{imagingTestDetails.report && renderLongInformations(imagingTestDetails.report)}</Content>
      <Footer>
        <Button onClick={handleOpenPacs} disabled={isDisabled}>
          <IconComponent name="arrowUpRightFromSquare" />
          <span>Visualizar Imagem</span>
        </Button>
      </Footer>
    </Container>
  )
}
